import Component from "../classes/Component";
import $ from 'jquery';
import 'jquery-match-height';

export default class FixHeight extends Component {
  constructor() {
    super({});
    this.element = [
      $("[data-components-fixHeight]"),
    ];
    this.init();
  }
  init() {
    if (this.element) {
      this.fixHeightCard();
    }
  }
  fixHeightCard() {
    $('.card-engagement .card-engagement__header__inside').matchHeight({
      byRow: true,
      property: 'height',
      target: null,
      remove: false
    });
  }
}
